module.exports = __webpack_public_path__ + "img/1标准研制.0adf266d.png";